import { render, staticRenderFns } from "./projectHandle.vue?vue&type=template&id=31164e12&scoped=true"
import script from "./projectHandle.vue?vue&type=script&lang=js"
export * from "./projectHandle.vue?vue&type=script&lang=js"
import style0 from "./projectHandle.vue?vue&type=style&index=0&id=31164e12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31164e12",
  null
  
)

export default component.exports